import { FilterConfig, TimePeriod } from '@hakimo-ui/hakimo/types';
import {
  AlarmGroupFilterValues,
  AlarmGroupStatus,
  PriorityLevel,
} from './types';

export const ALARM_GROUP_QUERY_INTERVAL = 42000;
export const TEMPORARY_RESOLVED_STATE_DURATION = 10000;
export const NEW_ALARM_GROUP_TOAST_ID = 'audio-notify-new-alarm-group';
interface StatusOption {
  id: AlarmGroupStatus;
  name: string;
}

const statusOptions: StatusOption[] = [
  { id: 'pending', name: 'Pending' },
  { id: 'in_progress', name: 'In Progress' },
  { id: 'resolved', name: 'Resolved' },
];

interface PriorityOption {
  id: string;
  name: PriorityLevel;
}

const priorityOptions: PriorityOption[] = [
  { id: 'high', name: 'High' },
  { id: 'low', name: 'Low' },
];

export const filterConfigs: FilterConfig[] = [
  {
    type: 'priority',
    label: 'Priority',
    defaultValue: {
      values: [],
      negative: false,
    },
    options: priorityOptions as any,
  },
  {
    type: 'status',
    defaultValue: {
      values: [],
      negative: false,
    },
    options: statusOptions as any,
  },
  {
    type: 'escalated',
    label: 'Resolution',
    defaultValue: undefined,
  },
  {
    type: 'location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'camera',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
];

export const defaultFilterValues: AlarmGroupFilterValues = {
  ...filterConfigs.reduce((acc, config) => {
    return { ...acc, [config.type]: config.defaultValue };
  }, {} as AlarmGroupFilterValues),
  time: {
    period: TimePeriod.PAST_24_HOURS,
    customRangeStart: 0,
    customRangeEnd: 0,
  },
};
